const DEFAULT_ICE_SERVERS = [
  {
    urls: 'stun:stun.l.google.com:19302'
  },
  {
    urls: 'stun:stun.yesdok.com:80',
    username: 'guestaja',
    credential: 'somepasswordaja'
  },
  {
    urls: 'turn:turn.yesdok.com:80',
    username: 'guestaja',
    credential: 'somepasswordaja'
  },
  {
    urls: 'stun:stun.yesdok.com:3478',
    username: 'guestaja',
    credential: 'somepasswordaja'
  },
  {
    urls: 'turn:turn.yesdok.com:3478',
    username: 'guestaja',
    credential: 'somepasswordaja'
  }
]

export const state = () => ({
  detectLoading: false,
  data: {
    osName: null,
    osVersion: null,
    browser: {},
    isWebsiteHasWebcamPermissions: false,
    isWebsiteHasMicrophonePermissions: false
  },
  photoStream: null,
  downloadSpeed: null,
  showPermissionInfoBlock: false,
  showSignalInfoBlock: false,
  showEnoughHardwareBlock: false,
  allowConsult: true,
  ramSize: null,
  minimumReqRam: 4,
  iceCandidates: [],
  RTCDetectReload: false,
  networkSpeed: null,
  audioLabel: null,
  device: {
    isAndroid: false,
    isChromeIpad: false,
    isChromeMac: false,
    isChromeWindows: false,
    isSafariIpad: false,
    isSafariMac: false
  },
  isSupportNetworkCheck: false,
  turnServers: DEFAULT_ICE_SERVERS
})

export const getters = {
  getDataHardware: (state) => {
    return state.data
  }
}

export const mutations = {
  SET_DATA: (state, data) => {
    state.data = data
  },

  SET_LOADING: (state, loading) => {
    state.detectLoading = loading
  },
  SET_PHOTO_STREAM: (state, value) => {
    state.photoStream = value
  },
  ADD_NEW_CANDIDATE: (state, value) => {
    state.iceCandidates.push(value)
  },
  RESET_CANDIDATE: (state, value) => {
    state.iceCandidates = []
  },
  SET_DOWNLOAD_SPEED: (state, value) => {
    state.downloadSpeed = value
  },
  SET_RAM_SIZE: (state, value) => {
    state.ramSize = value
  },
  SET_SHOW_PERMISSION_INFO_BLOCK: (state, value) => {
    state.showPermissionInfoBlock = value
  },
  SET_SHOW_SIGNAL_INFO_BLOCK: (state, value) => {
    state.showSignalInfoBlock = value
  },
  SET_SHOW_ENOUGH_HARDWARE_BLOCK: (state, value) => {
    state.showEnoughHardwareBlock = value
  },
  SET_ALLOW_CONSULT: (state, value) => {
    state.allowConsult = value
  },
  SET_RTC_DETECT_RELOAD: (state, value) => {
    state.RTCDetectReload = value
  },
  SET_NETWORK_SPEED: (state, value) => {
    state.networkSpeed = value
  },
  RESET_RTC_DATA: (state) => {
    state.data = {
      osName: null,
      osVersion: null,
      browser: {},
      isWebsiteHasWebcamPermissions: false,
      isWebsiteHasMicrophonePermissions: false
    }
  },
  SET_AUDIO_LABEL: (state, value) => {
    state.audioLabel = value
  },
  SET_DEVICE: (state, payload) => {
    state.device = payload
  },
  SET_SUPPORT_NETWORK_CHECK: (state, value) => {
    state.isSupportNetworkCheck = value
  },
  SET_TURN_SERVERS: (state, value) => {
    state.turnServers = value
  }
}

export const actions = {
  checkMinimumHardware ({ commit, state }) {
    if (state.data) {
      commit('SET_SHOW_PERMISSION_INFO_BLOCK', false)
      commit('SET_SHOW_ENOUGH_HARDWARE_BLOCK', false)
      commit('SET_ALLOW_CONSULT', true)

      if (!state.data.isWebsiteHasWebcamPermissions ||
        !state.data.isWebsiteHasMicrophonePermissions) {
        commit('SET_SHOW_PERMISSION_INFO_BLOCK', true)
        commit('SET_ALLOW_CONSULT', false)
      } else if (state.ramSize < state.minimumReqRam) {
        commit('SET_SHOW_ENOUGH_HARDWARE_BLOCK', true)
        commit('SET_ALLOW_CONSULT', true)
      }
    }
  },
  checkMinimumInternetSpeed ({ commit, state }) {
    commit('SET_SHOW_SIGNAL_INFO_BLOCK', false)
    commit('SET_ALLOW_CONSULT', true)

    if (state.downloadSpeed < 2) {
      commit('SET_SHOW_SIGNAL_INFO_BLOCK', true)
      commit('SET_ALLOW_CONSULT', false)
    }
  },
  minimumHardwareStatus ({ state }) {
    return new Promise((resolve, reject) => {
      const ret = {
        status: 'BAD'
      }

      if (state.data) {
        if (!state.data.isWebsiteHasWebcamPermissions ||
          !state.data.isWebsiteHasMicrophonePermissions) {
          ret.status = 'BAD'
        } else if (state.ramSize < state.minimumReqRam) { ret.status = 'ENOUGH' } else { ret.status = 'GOOD' }
      }

      resolve(ret)
    })
  },
  async fetchTurnServers ({ commit }) {
    try {
      const res = await this.$api.get('/public/rtc/turn')
      if (res.data && res.data.Data) {
        commit('SET_TURN_SERVERS', res.data.Data.iceServers)
      }
      return true
    } catch (error) {
      return true
    }
  }
}
